export enum RejectTypes {
  ReturnPortal = "Return portal",
  ManualReview = "Manual review",
  PreShipment = "Pre-shipment",
  Expired = "Expired",
  PostShipment = "Post-shipment",
}
